export type ReferralCodeSubmissionSource = "registration" | "cart" | "checkout" | "account_dashboard" | null;

export type ReferralCustomerType = {
  id: string;
  uuid: string;
  code: string;
  parent_code: string;
  tenant_code: string;
  has_first_purchase: boolean | null;
};

export type ReferralStatusResponseType = {
  isActive: boolean;
};

export type VerifyResponseType = {
  is_valid: boolean;
};

export type GetReferralStatsResponseType = {
  earned_points: number;
  referees_count: number;
  completed_first_order_count: number;
};

export type ReferralApiContract = {
  getStatus: () => Promise<boolean>;
  getCustomer: (uuid: string, ciam_token: string, skipCache?: boolean) => Promise<ReferralCustomerType>;
  verifyCode: (code: string, ciam_token: string) => Promise<boolean>;
  getReferralStats: (customer_uuid: string, ciam_token: string) => Promise<GetReferralStatsResponseType>;
  updateReferralCode: (
    uuid: string,
    referral_code: string,
    ciam_token: string,
    source?: ReferralCodeSubmissionSource
  ) => Promise<boolean>;
};
